export const promo = {
  newInPro: "Novedad en Pro",
  newInPlus: "Novedad en Plus",
  newInExpert: "Prueba · Novedad en Expert",
  videoTitle: "¿Cuánto valen tus cosas?",
  videoText:
    "Graba una habitación y sacamos todo lo de valor que encontremos. Recibes una lista con valores estimados y borradores de anuncios listos.",
  videoBullet1: "Graba la habitación, nosotros listamos las cosas",
  videoBullet2: "El total aparece al instante, tú eliges qué vender",
  videoCta: "Escanear un vídeo",
  getPro: "Consigue Pro",
  photoTitle: "Fotografía varios artículos a la vez",
  photoText:
    "Camina y haz fotos, sube hasta {{max}} imágenes por ronda. Agrupamos las imágenes del mismo artículo y le ponemos un valor estimado.",
  photoCta: "Fotografiar los artículos",
  getPlus: "Consigue Plus",
  deepTitle: "Escaneo profundo de un solo artículo",
  deepText:
    "Profundizamos: modelo exacto, estado y precios reales de venta. Obtienes un rango de precio fiable y un texto de anuncio listo, antes de poner precio.",
  deepCta: "Escaneo profundo",
  getExpert: "Consigue Expert",
} as const;
